import { useMemo } from "react";
import { useApporteurKpis } from "@/hooks/queries/useApporteurKpis";
import { useClientKpis } from "@/hooks/queries/useClientKpis";

interface ClientsReferrersAnalyticsParams {
  from: string;
  to: string;
  basis: "accrual" | "cash";
}

export function useClientsReferrersAnalytics({
  from,
  to,
  basis,
}: ClientsReferrersAnalyticsParams) {
  const params = useMemo(() => ({ from, to, basis }), [basis, from, to]);
  const { data: clients = [], isLoading: loadingClients } = useClientKpis(params);
  const { data: referrers = [], isLoading: loadingReferrers } = useApporteurKpis(params);

  return {
    clients,
    referrers,
    loading: loadingClients || loadingReferrers,
  };
}
